<div class="loader">
  <mat-progress-bar *ngIf="loading" mode="indeterminate" [color]="colour" />
</div>
<ng-content />
